export const GET_AUTHORS = 'GET_AUTHORS';
export const GET_AUTHOR_BY_ID = 'GET_AUTHOR_BY_ID';
export const UPDATE_AUTHOR = 'UPDATE_AUTHOR';
export const DELETE_AUTHOR = 'DELETE_AUTHOR';
export const CREATE_AUTHOR = 'CREATE_AUTHOR';
